// The Main Site Object
window.Site = {

    langs : document.querySelector('#langs'),

    searchBtn   : document.querySelector('.js-search-btn'),
    searchForm  : document.querySelector('.js-search-form'),
    searchField : document.querySelector('.js-search-field'),

    langsBtn   : document.querySelector('.js-lang-btn'),
    langsModal : document.querySelector('.js-lang-list'),

    // Init Function
    liftoff : () => {
        //Site.onClickRemoveCookieBanner()
        //Site.onLoadDisplayCookieBanner()
        Site.showHideSearch()
        Site.showHideLangs()
    },

    // Generate The Cookie Banner
    onClickRemoveCookieBanner : () => {

        if (!Site.cookieBannerButton) return;

        Site.cookieBannerButton.addEventListener('click' , () => {

            if (localStorage.banner !== 'displayed')
                localStorage.banner = 'displayed';

            // Remove The Banner
            document.querySelector('.gocciola').remove();

        })
    },

    // We need to create and display the cookie banner
    onLoadDisplayCookieBanner : () => {

        if (localStorage.banner !== 'displayed') {
            
            // Create the banner DOM 
            Site.banner = document.createElement('div');
            Site.banner.classList.add('gocciola');

            // The Left Column
            Site.bannerText = document.createElement('div');
            Site.bannerText.classList.add('gocciola-text');

            // The Right Column
            Site.bannerButton = document.createElement('div');
            Site.bannerButton.classList.add('gocciola-button');


            // We need to create the content for the two columns
            Site.bannerTextContent  = document.createElement('p')
            Site.bannerButtonContent = document.createElement('button')

            // Set the text message
            Site.bannerTextContent.innerHTML  = "We use cookies"
            Site.bannerButtonContent.innerHTML = "Ok"

            // Append the two columns to the main banner
            Site.bannerText.appendChild(Site.bannerLeftContent)
            Site.bannerButton.appendChild(Site.bannerRightContent)

            // Append the two columns to the main banner
            Site.banner.appendChild(Site.bannerText)
            Site.banner.appendChild(Site.bannerButton)

            // Append the banner to the body
            document.body.appendChild(Site.banner);

        }

    },

    // SHow hide the search on mobile
    showHideSearch : () => {

        Site.searchBtn.addEventListener('click' , () => {
            Site.searchForm.classList.add('is-visible')
            Site.searchField.focus()
        })

        Site.searchField.addEventListener('focusout' , () => {
            Site.searchForm.classList.remove('is-visible')
        })
    },

    // Show Hide Langs Dialogue
    showHideLangs : () => {
        Site.langsBtn.addEventListener('click' , () => {
            Site.langsModal.showModal();
        })

        Site.langsModal.addEventListener('click' , (e) => {
            if (e.target == Site.langsModal)
                Site.langsModal.close();
        })
    },

    // Products Functions
    Products : {

        // The components we need
        container          : document.querySelector('.products-links'),
        viewBtns           : document.querySelectorAll('.view-button'),
        btnActive          : document.querySelector('.view-button.active'),
        filters            : document.querySelectorAll('.js-product-filter-button'),
        thumbs             : document.querySelectorAll('.product-link'),
        products           : document.querySelector('#list'),
        clearBtns          : document.querySelectorAll('.filter-clear'),
        views              : document.getElementById('views'),
        images             : document.querySelectorAll('.thumb-image,.product-image,.thumb-view-all-image'),
        viewAll            : document.querySelectorAll('.thumb-view-all'),
        hideAll            : document.querySelectorAll('.thumb-specs'),
        showAll            : document.querySelector('.show-all-products'),
        showAllProducts    : document.querySelector('.show-all-products'),
        showAllCollections : document.querySelector('.show-collections'),
        showAllPreviews    : document.querySelector('.show-previews'),
        rotate             : document.querySelector('.rotate-button'),

        // Lazyload the images
        lazyloadImages : () => {

            // If we don't have the intersaction observer make the images visible right away
            if (!window.IntersectionObserver) {
                Site.Products.images.forEach( function(image) {
                    image.setAttribute('src' , image.dataset.src)
                    image.removeAttribute('data-src')
                })
            }
            
            // Show the images when the page is scrolled
            if (!!window.IntersectionObserver) {

                // Create the Interection Observer
                const IO = new IntersectionObserver((entries, observer) => { 
                    entries.forEach(image => {
                        if (image.isIntersecting) {
                            image.target.setAttribute('src' , image.target.dataset.src)
                            image.target.removeAttribute('data-src')
                            observer.unobserve(image.target);
                        }
                    });
                });

                Site.Products.images.forEach(image => { IO.observe(image) });
            }

        },





        // Show the different views when the button is clicked
        changeProductsView : () => {

            // Rotate View
            if (Site.Products.rotate) {

                Site.Products.rotate.addEventListener('click' , () => {

                    // Grab the current value
                    let currentView = Site.Products.container.dataset.view;
                    let nextView    = null;
                    switch (currentView) {
                        case "front":
                            nextView = "side";
                            break;
                        case "side":
                            nextView = "back";
                            break;
                        case "back":
                            nextView = "front";
                            break;
                    } 

                    Site.Products.container.setAttribute('data-view' , nextView);

                })


            }


            if (Site.Products.views) {

                // Change view using the dropdown
                Site.Products.views.addEventListener('change' , () => {
                    Site.Products.container.setAttribute('data-view' , Site.Products.views.value);
                    document.querySelector('.view-button.active').classList.remove('active')
                    document.querySelector(`.view-button[value="${Site.Products.views.value}"]`).classList.add('active')
                })

            }

            Site.Products.viewBtns.forEach(btn => {
                btn.addEventListener('click' , (e) => {

                    // grab the clicked button
                    let target  = e.target;
                    if (target == Site.Products.btnActive) return;

                    target.classList.add('active')
                    Site.Products.btnActive.classList.remove('active')

                    Site.Products.btnActive = target;
                    Site.Products.container.setAttribute('data-view' , target.value);

                    Site.Products.views.value = target.value;

                })
            })
        },

        // Filter The Products List When A filter Is Selected
        filterProducts : () => {
            Site.Products.filters.forEach(filter => {
                filter.addEventListener('click' , () => {

                    // First we check if there is already an active filter
                    let activeFilters = document.querySelectorAll('.js-product-filter-button.is-selected')
                    let activeArray   = Array.from(activeFilters)

                    // If there's already an active button and it's not the currently pressed one remove the class form the buttons
                    if (activeFilters && !activeArray.includes(filter))
                        activeFilters.forEach(activeFilter => {activeFilter.classList.remove('is-selected')})

                    // Add the active class on each button when clicked
                    let currentFilters = document.querySelectorAll(`.js-product-filter-button[value="${filter.value}"]`)
                        currentFilters.forEach(currentFilter => {currentFilter.classList.toggle('is-selected')})
                    
                    if (filter.classList.contains('is-selected')) {
                        Site.Products.thumbs.forEach(p => {p.classList.add('is-hidden')})
                        document.body.classList.add('filtered-products')
                        Site.Products.container.querySelectorAll(`.product-link[data-filters*="${filter.value}"]`).forEach(p => {p.classList.remove('is-hidden')})
                    } else {
                        document.body.classList.remove('filtered-products')
                        Site.Products.thumbs.forEach(p => {p.classList.remove('is-hidden')})
                    }

                    // Scroll Products Into View
                    if (filter.classList.contains('is-selected') && !filter.classList.contains('sidebar-button')) {
                        Site.Products.products.scrollIntoView({block: "start"});
                    }
                

                })
            })
        },

        // Clear selection when a clear button is selected
        clearFilters : () => {
            Site.Products.clearBtns.forEach(btn => {
                btn.addEventListener('click' , () => {

                    document.body.classList.remove('filtered-products')
                    
                    // First we check if there is already an active filter
                    let active = document.querySelectorAll('.js-filter-button.is-selected');
                    if (active) {
                        active.forEach(a => {a.classList.remove('is-selected')});
                    }

                    Site.Products.thumbs.forEach(p => {p.classList.remove('is-hidden')})
                    if (btn.classList.contains('grid-thumb')) {
                        Site.Products.products.scrollIntoView({block: "start"});
                    }

                })
            })


        },

        // Display All products in the collection
        viewAllInCollection : () => {

            // When the button is clicked, hide everything but the collections
            if (Site.Products.showAllCollections) {
            Site.Products.showAllCollections.addEventListener('click' , () => {

                // We need to toggle the custom class for the products container
                document.querySelector('#js-products').classList.add('is-collection-mode')

                // Find all the products that need a class toggle
                document.querySelectorAll('a.thumb,.thumb-specs').forEach(item => {
                    item.classList.add('thumb-is-hidden')
                })

                document.querySelectorAll('button.thumb-view-all').forEach(item => {
                    item.classList.remove('thumb-is-hidden')
                })

            })
            }

            // When the button is clicked, hide everything but the previews
            if (Site.Products.showAllPreviews) {
                Site.Products.showAllPreviews.addEventListener('click' , () => {

                    document.querySelector('#js-products').classList.remove('is-collection-mode')

                    // Find all the products that need a class toggle
                    document.querySelectorAll('a.thumb,.thumb-specs').forEach(item => {
                        item.classList.add('thumb-is-hidden')
                    })

                    document.querySelectorAll('button.thumb-view-all').forEach(item => {
                        item.classList.remove('thumb-is-hidden')
                    })

                })
            }


            if (Site.Products.showAll) {

                Site.Products.showAll.addEventListener('click' , () => {

                    document.querySelector('#js-products').classList.remove('is-collection-mode')

                    // Find all the products that need a class toggle
                    document.querySelectorAll('a.thumb').forEach(item => {
                        item.classList.remove('thumb-is-hidden')
                    })

                    document.querySelectorAll('button.thumb').forEach(item => {
                        item.classList.add('thumb-is-hidden')
                    })

                })


            }

            Site.Products.viewAll.forEach(button => {
                button.addEventListener('click' , () => {

                    // Grab The Slug
                    let slug = button.value;

                    // Find all the products that need a class toggle
                    let products = document.querySelectorAll(`.thumb-is-hidden[data-slug="${slug}"], .thumb-was-hidden[data-slug="${slug}"]`);
                    products.forEach(product => {
                        product.classList.toggle('thumb-is-hidden')
                        product.classList.toggle('thumb-was-hidden')
                    })

                    button.classList.toggle('thumb-is-hidden')
                    button.nextElementSibling.classList.toggle('thumb-is-hidden')

                })
            })

            Site.Products.hideAll.forEach(button => {
                button.addEventListener('click' , () => {

                    // Grab The Slug
                    let slug = button.value;

                    // Find all the products that need a class toggle
                    let products = document.querySelectorAll(`.thumb-is-hidden[data-slug="${slug}"], .thumb-was-hidden[data-slug="${slug}"]`);
                    products.forEach(product => {
                        product.classList.toggle('thumb-is-hidden')
                        product.classList.toggle('thumb-was-hidden')
                    })

                    button.classList.toggle('thumb-is-hidden')
                    button.previousElementSibling.classList.toggle('thumb-is-hidden')

                })
            })

        },

    },

    Views : {

        container : document.querySelector('.products-links'),
        btns      : document.querySelectorAll('.view-button'),
        btnActive : document.querySelector('.view-button.active'),

        btnsViewAll : document.querySelectorAll('.view-all'),

        // Show all items inside the grid
        showAll : () => {
            Site.Views.btnsViewAll.forEach(btn => {
                btn.addEventListener('click' , () => {
                    let value  = btn.value;
                    let parent = document.getElementById(value).parentElement.parentElement;
                    let video  = parent.querySelector('.finish-preview-video');
                    
                    // Expand the section
                    parent.classList.toggle('expanded')

                    // If there's a video, play it or pause it
                    if (video) {

                        if (!video.src)
                            video.src = video.dataset.src

                        if (video.paused) {
                            video.play()
                        } else { 
                            video.pause()
                        }
                    }



                    
                })
            })
        }

    },

    Swatch : {

        swatches : document.querySelectorAll('.swatch-image'),

        initZoom : () => {
            Site.Swatch.swatches.forEach(swatch => {

                swatch.addEventListener('click' , Site.Swatch.zoomIn.bind(null,swatch),false)

            })
        },

        zoomIn : (swatch) => {
            swatch.classList.add('zoomed')
            let src = swatch.dataset.original;
            swatch.setAttribute('data-original' , swatch.src)
            swatch.setAttribute('src' , src)

            swatch.addEventListener('click' , Site.Swatch.zoomOut.bind(null,swatch),false)
            swatch.removeEventListener('click' , Site.Swatch.zoomIn)
        },

        zoomOut : (swatch) => {
            swatch.classList.remove('zoomed')
            let src = swatch.dataset.original;
            swatch.setAttribute('data-original' , swatch.src)
            swatch.setAttribute('src' , src)
            swatch.addEventListener('click' , Site.Swatch.zoomIn.bind(null,swatch),false)
            swatch.removeEventListener('click' , Site.Swatch.zoomOut)
        },

    },

    // Finishes Functions
    Finishes : {

        // The components we need
        filters        : document.querySelectorAll('.js-finish-filter-button'),
        finishes       : document.querySelectorAll('.finish'),
        finishesList   : document.querySelector('.finishes'),
        finishesSearch : document.querySelector('.js-finishes-search'),

        // Preview video and image
        finishVideos : document.querySelectorAll('.finish-preview-video'),
        finishImages : document.querySelectorAll('.finish-preview-image'),

        // We need to lazyload the hell out of these sections
        displayOnScroll : () => {
        
            // If we don't have the intersaction observer add all the classes
            if (!window.IntersectionObserver) {

                // Swap in all the images
                Site.Finishes.finishes.forEach(function(finish){
                    finish.querySelectorAll('.swatch-image').forEach(image => {
                        image.setAttribute('src' , image.dataset.src)
                        image.removeAttribute('data-src')
                    })
                })

                // Swap in the videos
                Site.Finishes.finishVideos.forEach(function(video){
                    video.src = video.dataset.src
                    video.play()
                })
            }
            
            // Show the images when the page is scrolled
            if (!!window.IntersectionObserver) {

                // Create the Interection Observer
                const IO = new IntersectionObserver((entries, observer) => { 
                    entries.forEach(finish => {
                        if (finish.isIntersecting) {

                            // If we're working with a finish
                            if (finish.target.classList.contains('finish')) {
                                finish.target.querySelectorAll('.swatch-image').forEach(image => {
                                    image.setAttribute('src' , image.dataset.src)
                                    image.removeAttribute('data-src')
                                })
                            }

                            // If we're working with a video
                            if (finish.target.classList.contains('finish-preview-video')) {
                                finish.target.src = finish.target.dataset.src
                                finish.target.play()
                            }

                            // If we're working with an Image
                            if (finish.target.classList.contains('finish-preview-image')) {
                                finish.target.src = finish.target.dataset.src
                            }

                            observer.unobserve(finish.target);
                        }
                    });
                });

                Site.Finishes.finishes.forEach(finish => { IO.observe(finish) });
                Site.Finishes.finishVideos.forEach(finish => { IO.observe(finish) });
                Site.Finishes.finishImages.forEach(finish => { IO.observe(finish) });
            }
        },

        // Filter The Products List When A filter Is Selected
        filterFinishes : () => {
            Site.Finishes.filters.forEach(filter => {
                filter.addEventListener('click' , () => {

                    // First we check if there is already an active filter
                    let activeFilter = document.querySelector('.js-finish-filter-button.is-selected')

                    // If there's already an active button and it's not the currently pressed one remove the class form the buttons
                    if (activeFilter && activeFilter != filter)
                        activeFilter.classList.remove('is-selected')

                    // Add the active class on each button when clicked
                    filter.classList.toggle('is-selected')
                    
                    if (filter.classList.contains('is-selected')) {
                        Site.Finishes.finishes.forEach(p => {p.classList.add('is-hidden')})
                        document.body.classList.add('filtered-finishes')
                        Site.Finishes.finishesList.querySelectorAll(`.finish[data-filters*="${filter.value}"]`).forEach(p => {p.classList.remove('is-hidden')})
                    } else {
                        document.body.classList.remove('filtered-finishes')
                        Site.Finishes.finishes.forEach(p => {p.classList.remove('is-hidden')})
                    }
                

                })
            })
        },

        // Filter Using The Search
        searchInsideText : () => {

            Site.Finishes.finishesSearch.addEventListener('input' , (event) => {

                // Get the current typed value
                let query = event.target.value.toLowerCase();
                
                // Loop through each filter and check if we have a match
                Site.Finishes.finishes.forEach(finish => {

                    // We need to extract the text content from the finish
                    let title = finish.querySelector('.finish-title');
                    let desc  = finish.querySelector('.swatch-text');
                    let data  = null;
                    if (title)  { data += title.innerText }
                    if (desc)   { data += desc.innerText }

                    // Perform a search inside the text data
                    let result = data.toLowerCase().search(query);

                    if (result < 0 && !finish.classList.contains('is-hidden'))
                        finish.classList.add('is-hidden')

                    if (result > 0 && finish.classList.contains('is-hidden'))
                        finish.classList.remove('is-hidden')

                })

            })

        }

    },

    // Sidebar Functions
    Sidebar : {

        // Sidebar Items
        container : document.querySelector('.js-sidebar'),
        buttons   : document.querySelectorAll('.js-btn-sidebar'),

        // Show hide the sidebar on click
        showHideOnClick : () => {
            
            document.body.addEventListener('fewf' , (event) => {
                console.log(event.target)
                if (document.body.classList.contains('filtered-products')) {
                    document.body.classList.remove('filtered-products')
                    document.querySelector('.js-sidebar.is-visible').classList.remove('is-visible')
                }
            })

            Site.Sidebar.buttons.forEach(btn => {
                btn.addEventListener('click' , () => {

                    // Get the active sidebar
                    let activeSidebar = document.querySelector('.js-sidebar.is-visible')
                    console.log(activeSidebar)
                    let targetSidebar = document.getElementById(btn.value)

                    if (activeSidebar && activeSidebar != targetSidebar) {
                        activeSidebar.classList.remove('is-visible')
                    }

                    targetSidebar.classList.toggle('is-visible')
                    document.body.classList.toggle('sidebar-open')
                })
            })

        }

    },

    // Video Related Functions
    Video : {

        section      : document.querySelector('.product-video-section-origins'),
        videos       : document.querySelectorAll('.product-video'),
        activeHolder : document.querySelector('.product-video-active'),
        activeVideo  : document.querySelector('.product-video-active video'),

        active       : document.querySelector('.product-video-active'),
        thumbs       : document.querySelectorAll('.product-video-thumb-holder'),
        playingVideo : document.querySelector('.product-video-playing'),

        // Change the active video on click
        updateActiveVideo : () => {
            Site.Video.thumbs.forEach(thumb => {

                thumb.addEventListener('click' , (event) => {

                    // Check if the clicked video is not the acrtive one
                    if (thumb.classList.contains('product-video-active')) return;

                    Site.Video.active.classList.remove('product-video-active')
                    Site.Video.active = thumb;
                    Site.Video.active.classList.add('product-video-active')

                    Site.Video.playingVideo.src = thumb.dataset.src


                })

            })
        }
        

    }


}

// Launch The Script 
Site.liftoff()